export const COMPANY = {
    name: "WorkAssign AI",
    legal: "Virox WorkAssign Technology Private Limited",
    tagline: "AI Employees for Every Business",
    motto: "Same Work. Less Cost. More Growth.",
    actionLine: "Call. Chat. Manage. Follow Up. Automate. Grow.",
    whatsapp: "https://wa.me/919685099792",
    phoneDisplay: "+91 96850 99792",
    maps: "https://maps.app.goo.gl/jgZfqkKY2zgvnoDB9",
    website: "https://www.workassign.in",
};

export const SOCIALS = [
    { name: "Instagram", href: "https://www.instagram.com/workassignai?rpxt=NHBjdGJycWJ6Z3Vy", icon: "instagram" },
    { name: "Facebook", href: "https://www.facebook.com/share/1F6vyR5byb/?mibextid=wwXIfr", icon: "facebook" },
    { name: "X (Twitter)", href: "https://x.com/workassignai?s=11", icon: "twitter" },
    { name: "YouTube", href: "https://youtube.com/@workassignai?si=qPNx7IzOC4rBlA0s", icon: "youtube" },
    { name: "Google Business", href: "https://maps.app.goo.gl/jgZfqkKY2zgvnoDB9", icon: "map" },
];

export const PRESS = [
    "Dainik Bhaskar",
    "Dainik Jagran",
    "India News",
    "Inkhabar",
    "Loktej",
    "Jio News",
    "Dailyhunt",
    "UP 18 News",
    "Business Patra",
    "Google News",
    "Sangri Today",
    "Hello Entrepreneurs",
];

export const PRODUCTS = [
    {
        id: "whatsapp",
        name: "AI WhatsApp Agent",
        desc: "Talks to every customer instantly, 24/7 — answers FAQs, qualifies leads, books appointments and nurtures them automatically.",
        features: ["Customer conversations", "Lead qualification", "FAQ handling", "Follow-ups", "Appointment booking", "Lead nurturing"],
        accent: "text-emerald-400",
        chip: "bg-emerald-500/10 border-emerald-500/25 text-emerald-300",
        iconBg: "bg-emerald-500/15 text-emerald-400",
    },
    {
        id: "calling",
        name: "AI Calling Agent",
        desc: "Makes intelligent, natural-sounding AI calls in multiple languages — without expanding your team by a single person.",
        features: ["Outbound AI calls", "Lead qualification", "Follow-up calls", "Appointment scheduling", "Enquiry handling", "Call analytics"],
        accent: "text-cyan-400",
        chip: "bg-cyan-500/10 border-cyan-500/25 text-cyan-300",
        iconBg: "bg-cyan-500/15 text-cyan-400",
    },
    {
        id: "autopilot",
        name: "AI Autopilot",
        desc: "Connects WhatsApp, AI calling and your CRM into one AI team that moves every enquiry from first message to closed opportunity.",
        features: ["Lead capture", "Qualification", "Follow-up", "Appointment booking", "Lead nurturing", "Sales handoff"],
        accent: "text-blue-400",
        chip: "bg-blue-500/10 border-blue-500/25 text-blue-300",
        iconBg: "bg-blue-500/15 text-blue-400",
    },
];

export const CAPABILITIES = [
    { name: "Calling", desc: "AI calling agents for sales & support", accent: "text-cyan-400", iconBg: "bg-cyan-500/15 text-cyan-400" },
    { name: "WhatsApp", desc: "Automated WhatsApp support", accent: "text-emerald-400", iconBg: "bg-emerald-500/15 text-emerald-400" },
    { name: "CRM", desc: "Manage leads & customers", accent: "text-violet-400", iconBg: "bg-violet-500/15 text-violet-400" },
    { name: "Follow-up", desc: "Automated follow-ups", accent: "text-amber-400", iconBg: "bg-amber-500/15 text-amber-400" },
    { name: "Support", desc: "24/7 customer support", accent: "text-sky-400", iconBg: "bg-sky-500/15 text-sky-400" },
    { name: "Automation", desc: "End-to-end business automation", accent: "text-teal-400", iconBg: "bg-teal-500/15 text-teal-400" },
];

export const STEPS = [
    { n: "01", title: "Recharge", desc: "Start with a ₹499 recharge and choose AI Calling minutes or Customer Messages." },
    { n: "02", title: "Train Your AI", desc: "Upload your shop details, products, prices, working hours and common customer questions." },
    { n: "03", title: "Connect Your Business", desc: "Connect supported calling and messaging channels to your AI employee." },
    { n: "04", title: "Pay Only for Usage", desc: "Balance is deducted only when your AI handles a billable customer call or message." },
];

export const INDUSTRIES = [
    { name: "Shoe Shops", desc: "AI answers price, size and new-arrival questions instantly.", icon: "shoe" },
    { name: "Clothing Stores", desc: "Handles collection enquiries and shares catalogues on WhatsApp.", icon: "shirt" },
    { name: "Grocery Stores", desc: "Takes orders and product questions even when the shop is busy.", icon: "cart" },
    { name: "Beauty Salons", desc: "Books appointments and answers service & pricing queries.", icon: "scissors" },
    { name: "Mobile Shops", desc: "Handles model, price and EMI questions 24/7.", icon: "phone" },
    { name: "Wholesalers", desc: "Manages bulk-order enquiries and dealer follow-ups.", icon: "package" },
    { name: "Suppliers & Distributors", desc: "Answers availability and rate queries from retailers.", icon: "truck" },
    { name: "Restaurants", desc: "Takes table bookings and menu questions automatically.", icon: "food" },
    { name: "Clinics", desc: "Patient enquiries, timings and appointment booking.", icon: "stethoscope" },
    { name: "Coaching Institutes", desc: "Admission enquiries, fees and batch details handled by AI.", icon: "graduation" },
    { name: "E-commerce Stores", desc: "Order status, returns and product support on autopilot.", icon: "bag" },
    { name: "Real Estate & Services", desc: "Qualifies buyers and schedules site visits or consultations.", icon: "building" },
];

export const PLANS = [
    {
        id: "small",
        name: "Small Business",
        price: "₹499",
        period: "/recharge",
        tagline: "Your Personal AI Receptionist. Pay Only When You Use It.",
        audience: "Shoe shops, clothing stores, kirana stores, salons, suppliers, retailers, service providers & solo business owners.",
        badge: "PREPAID RECHARGE",
        accent: "cyan",
        highlight: true,
        options: [
            { id: "A", label: "Option A", value: "50 AI Calling Minutes" },
            { id: "B", label: "Option B", value: "500 WhatsApp Messages" },
        ],
        features: [
            "24×7 AI customer assistance",
            "Automatic incoming call responses",
            "AI WhatsApp enquiry handling",
            "Product details & pricing assistance",
            "Customer FAQs answered instantly",
            "Basic lead capture",
            "Messages are WhatsApp only — SMS not included",
            "No mandatory monthly subscription",
            "No automatic recharge",
            "Pay-as-you-go usage",
            "Recharge whenever needed",
        ],
        note: "No enquiry? No usage charge. Balance deducts only on real, billable usage.",
        cta: "Start with ₹499",
    },
    {
        id: "enterprise",
        name: "Enterprise Premium",
        price: "₹40,000",
        period: "/month",
        tagline: "Your Complete AI Workforce. One Powerful Platform.",
        bestFor: "Large companies, multi-branch businesses, real estate, agencies, e-commerce, financial services, healthcare & education companies.",
        badge: "MONTHLY SUBSCRIPTION",
        accent: "amber",
        highlight: false,
        premium: true,
        features: [
            "Advanced AI calling & WhatsApp automation",
            "AI sales & customer support",
            "Enterprise CRM & automations",
            "Multi-department AI workflows",
            "Up to 20 team members",
            "Role-based user access",
            "Manager monitoring dashboard",
            "Call recording & summaries",
            "Product catalogue & media sharing",
            "Custom AI agent training",
            "API & CRM integrations",
            "Multi-branch workflow support",
            "Multiple calling numbers & WhatsApp accounts",
            "Advanced analytics & reporting",
            "Custom conversation flows",
            "Configurable calling & messaging limits",
            "Priority support",
        ],
        note: "Calling minutes & message allowances configured with our team before activation.",
        cta: "Get Enterprise Plan",
    },
];

export const FAQS = [
    {
        q: "Do I have to recharge every month?",
        a: "No. The Small Business plan has no mandatory monthly subscription and no auto-recharge. Recharge only when you need the balance.",
    },
    {
        q: "What if no customer enquiry comes on a day?",
        a: "No usage charge is deducted. Balance is used only on real, billable AI calling or messaging — No Enquiry, No Usage Charge.",
    },
    {
        q: "What is an AI employee?",
        a: "An AI employee is a digital team member that handles real business work — answering customers on WhatsApp, making and receiving calls, qualifying leads, following up and booking appointments. It works 24/7, speaks multiple languages, and never forgets a follow-up.",
    },
    {
        q: "How fast can I go live?",
        a: "Most businesses go live within a few days. Our team sets up your AI agents, connects your WhatsApp and calling numbers, configures your workflows, and trains the AI on your business information during onboarding.",
    },
    {
        q: "Does it replace my team?",
        a: "No — it is a force multiplier. AI handles the repetitive top-of-funnel work (instant replies, qualification, follow-ups) so your human team spends time only on warm, qualified conversations and closing.",
    },
    {
        q: "Which languages does the AI speak?",
        a: "WorkAssign AI is built for Indian businesses — it handles multilingual conversations including Hindi and English, and can be configured for the languages your customers actually speak.",
    },
    {
        q: "Is my customer data safe?",
        a: "Yes. Data is stored securely, access is restricted, and our website forms are protected against bots and automated scraping. We never sell or share your business or customer data.",
    },
    {
        q: "Can I upgrade or cancel later?",
        a: "Yes. You can start with the ₹499 Small Business recharge and move to the Enterprise plan as you scale. Enterprise customers can opt for custom implementations.",
    },
];



export const BLOG_COVERS = {
    cyan: "from-cyan-500/30 via-blue-600/20 to-slate-900",
    blue: "from-blue-500/30 via-indigo-600/20 to-slate-900",
    teal: "from-teal-500/30 via-emerald-600/20 to-slate-900",
    amber: "from-amber-500/30 via-orange-600/20 to-slate-900",
    violet: "from-violet-500/30 via-purple-600/20 to-slate-900",
};

export const MEDIA_HEADLINE = "WorkAssign AI's Initiative to Bring AI Automation to Small Businesses";
export const MEDIA_DATE = "14 Sep 2026";

export const MEDIA_ARTICLES = [
    { name: "Dainik Bhaskar", url: "https://www.bhaskarhindi.com/technology/work-assign-ais-initiative-to-bring-ai-automation-to-small-businesses-1360871" },
    { name: "Dainik Jagran MP", url: "https://www.dainikjagranmpcg.com/business/work-assign-ai-initiative-to-bring-ai-automation-to-small/article-64272" },
    { name: "India News", url: "https://indianews.in/business/work-assign-ais-initiative-to-bring-ai-automation-to-small-businesses-924507/" },
    { name: "Inkhabar", url: "https://www.inkhabar.com/press-release/work-assign-ais-initiative-to-bring-ai-automation-to-small-businesses-289068/" },
    { name: "Loktej", url: "https://www.loktej.com/article/151454/work-assign-ai-initiative-to-bring-ai-automation-to-small" },
    { name: "Jio News", url: "https://www.loktej.com/article/151454/work-assign-ai-initiative-to-bring-ai-automation-to-small?utm_source=JioNews&utm_medium=referral&utm_campaign=JioNews" },
    { name: "Dailyhunt", url: "https://m.dailyhunt.in/news/india/hindi/loktej-epaper-lktjhi/chote+bijanes+tak+eaai+otomeshan+pahunchane+ki+disha+me+vark+asain+eaai+ki+pahal-newsid-n726862207?listname=newspaperLanding&index=36&topicIndex=0&mode=pwa&action=click" },
    { name: "UP 18 News", url: "https://up18news.com/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Hello Entrepreneurs", url: "https://helloentrepreneurs.in/work-assign-ais-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Samachar Sansaar", url: "https://samacharsansaar.com/business/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/19396/" },
    { name: "Business Patra", url: "https://businesspatra.com/work-assign-ais-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Google News", url: "https://news.google.com/search?q=%E0%A4%9B%E0%A5%8B%E0%A4%9F%E0%A5%87%20%E0%A4%AC%E0%A4%BF%E0%A4%9C%E0%A4%A8%E0%A5%87%E0%A4%B8%20%E0%A4%A4%E0%A4%95%20%E0%A4%8F%E0%A4%86%E0%A4%88&hl=hi&gl=IN&ceid=IN%3Ahi" },
    { name: "Sangri Today", url: "https://hindi.sangritoday.com/business/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Nation Republiq", url: "https://hindi.nationrepubliq.com/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "AGR News", url: "https://hindi.agrnews.co.in/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Education Daddy", url: "https://hindi.educationdaddy.in/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Sanchore Today", url: "https://hindi.sanchoretoday.com/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Jaipur Mirror", url: "https://hindi.jaipur-mirror.com/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Sangri TV", url: "https://hindi.sangritv.com/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "MBI24 News", url: "https://www.mbi24news.com/hindi/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "The Bizz Stories", url: "https://hindi.thebizzstories.com/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Ekaaina Bharat", url: "https://www.ekaainabharat.com/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Marudhara Bharti", url: "https://www.marudharabharti.com/business/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Barmer Bulletin", url: "https://www.barmerbulletin.com/business/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Jalore Live", url: "https://www.jalorelive.com/business/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Sangri Times", url: "https://www.sangritimes.com/business/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Marudhar Bharti", url: "https://www.marudharbharti.com/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "SP Times", url: "https://hindi.sptimes.in/work-assign-ai-initiatives-towards-ai-automation-for-small-businesses" },
    { name: "Talk Pedia", url: "https://hindi.talkpedia.in/2026/09/work-assign-ai-initiatives-towards-ai.html" },
    { name: "Rajasthan Horizon", url: "https://hindi.rajasthanhorizon.com/2026/09/work-assign-ai-initiatives-towards-ai.html" },
    { name: "Utkarsh News", url: "https://hindi.utkarshnews.com/2026/09/work-assign-ai-initiatives-towards-ai.html" },
    { name: "India Dazzle", url: "https://hindi.indiadazzle.com/2026/09/work-assign-ai-initiatives-towards-ai.html" },
    { name: "Allahabad Post", url: "https://allahabadpost.in/hindi/index.php/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Jodhpur Reporter", url: "https://jodhpurreporter.com/hindi/index.php/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Maharashtra 24x7", url: "https://maharashtra24x7.com/business-hindi/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Delhi News Watch", url: "https://delhinewswatch.com/hn/index.php/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Hola Mumbai", url: "https://holamumbai.com/business-hindi/%e0%a4%9b%e0%a5%8b%e0%a4%9f%e0%a5%87-%e0%a4%ac%e0%a4%bf%e0%a4%9c%e0%a4%a8%e0%a5%87%e0%a4%b8-%e0%a4%a4%e0%a4%95-%e0%a4%8f%e0%a4%86%e0%a4%88-%e0%a4%91%e0%a4%9f%e0%a5%8b%e0%a4%ae%e0%a5%87%e0%a4%b6/" },
    { name: "Kanpur Live", url: "https://kanpurlive.in/hn/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "UP Patrika", url: "https://hindi.up-patrika.com/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Indore Pioneer", url: "https://indorepioneer.com/2026/09/14/%e0%a4%9b%e0%a5%8b%e0%a4%9f%e0%a5%87-%e0%a4%ac%e0%a4%bf%e0%a4%9c%e0%a4%a8%e0%a5%87%e0%a4%b8-%e0%a4%a4%e0%a4%95-%e0%a4%8f%e0%a4%86%e0%a4%88-%e0%a4%91%e0%a4%9f%e0%a5%8b%e0%a4%ae%e0%a5%87%e0%a4%b6/" },
    { name: "Khabare Rajasthan", url: "https://khabarerajasthan.com/hindi/index.php/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Live Jabalpur", url: "https://livejabalpur.com/hn/index.php/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Live Mumbai", url: "https://hn.livemumbai.in/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Nashik 24", url: "https://nashik24.com/hindi/index.php/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Rajasthan Express", url: "https://hindi.rajasthanexpress.in/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Prakhar Jagaran", url: "https://prakharjagaran.com/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Satta Express", url: "https://sattaexpress.co.in/hn/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Shekhawati Samachar", url: "https://shekhawatisamachar.com/hindi/index.php/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
    { name: "Nagpur News Today", url: "https://nagpurnewstoday.com/2026/09/14/work-assign-ai-initiative-to-bring-ai-automation-to-small-businesses/" },
];
